import { Helmet } from "react-helmet"
import Layout from "../components/layout/Layout"
import Brand1 from "../components/sections/Brand1"
import ServiceDetails1 from "../components/sections/ServiceDetails1"
export default function ServicesDetails() {
	return (
		<>
			<Helmet>
				<title>V-Make | WPC Door Frames</title>
				<meta name="description" content="Explore V-Make’s high-quality WPC Door Frames that are water-resistant, termite-proof, and perfect for long-lasting interior and exterior applications." />
				<meta name="keywords" content="WPC door frames, V-Make door frames, termite-proof frames, waterproof door frames, eco-friendly frames, durable WPC frames, sustainable building materials" />
				<link rel="canonical" href="https://vmakewpc.com/wpc-door-frames" />
			</Helmet>
			<Layout
				headerStyle={1}
				footerStyle={1}
			// breadcrumbTitle="Services details"
			>
				<ServiceDetails1 />
				{/* <Brand1 /> */}
			</Layout>
		</>
	)
}
